import type { FileMapDataSubcategoryHiddenStyle } from '../../types'

export const defaultStyleHidden: FileMapDataSubcategoryHiddenStyle = {
  id: 'hidden',
  name: 'Ausgeblendet',
  layers: undefined,
  legends: undefined,
}
